import { useAuthContext } from '@/context/Context';

import { useNavigate } from 'react-router-dom';
import { books } from '../../data/steps';

export default function WhyCourse() {
  const navigate = useNavigate();
  const { loggedIn } = useAuthContext();

  // Create a reference with an initial file path and name

  const redirectToAmazon = (elm) => {
    window.open(elm.link, '_blank');
  };
  const onClickCard = (elm) => {
    switch (elm.id) {
      case 1:
      case 4:
        if (!loggedIn) {
          navigate('/login?redirect_to=/volumes/GVK1');
          return;
        }
        navigate('/exams');
        break;
      case 2:
      case 3:
      case 7:
      case 8:
        redirectToAmazon(elm);
        break;
      case 5:
        navigate('/freedownloads');
        break;

      default:
        // Handle any unexpected elm.id values
        console.warn('Unexpected card id:', elm.id);
        break;
    }
  };
  const getCardStyle = (index) => {
    // Unified dark theme with white/silver accent
    return {
      background: 'rgba(0, 0, 0, 0.6)',
      borderGradient:
        'linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1))',
      accentBackground: 'rgba(255, 255, 255, 0.05)',
      glowColor: 'rgba(255, 255, 255, 0.15)',
      accentColor: '#ffffff',
    };
  };

  const getButtonStyle = (style, cardStyle) => {
    // Enhanced glassmorphic button with accent colors
    return {
      borderRadius: '50px',
      padding: '18px 36px',
      fontWeight: '700',
      fontSize: '15px',
      letterSpacing: '0.8px',
      textTransform: 'uppercase',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
      minWidth: '200px',
      color: '#ffffff',
      backdropFilter: 'blur(15px)',
      background: `
        linear-gradient(135deg, 
          rgba(0, 0, 0, 0.8) 0%, 
          rgba(15, 15, 15, 0.7) 50%,
          rgba(0, 0, 0, 0.8) 100%
        )
      `,
      border: `2px solid ${cardStyle?.accentColor || '#ffffff'}30`,
      boxShadow: `
        0 15px 40px rgba(0, 0, 0, 0.5),
        0 0 20px ${cardStyle?.glowColor || 'rgba(255, 255, 255, 0.2)'},
        inset 0 2px 0 rgba(255, 255, 255, 0.15),
        inset 0 -1px 0 rgba(0, 0, 0, 0.2)
      `,
      textShadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
    };
  };

  return (
    <section
      style={{
        background: 'transparent',
        position: 'relative',
        overflow: 'hidden',
        minHeight: 'auto',
        paddingBottom: '3rem',
      }}
    >
      <div className='container'>
        {/* Books Grid */}
        <div
          className='books-grid'
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
            gap: '2.5rem',
            maxWidth: '1500px',
            margin: '0 auto',
            padding: '0 1rem',
            marginBottom: '4rem',
            marginTop: '2rem',
          }}
        >
          {books.map((book, bookIndex) => {
            const cardStyle = getCardStyle(bookIndex); // Use unified theme like steps

            return (
              <div
                key={book.id}
                data-aos='fade-up'
                data-aos-duration={600 + bookIndex * 100}
                data-aos-delay={bookIndex * 150}
                className='book-card'
                style={{
                  position: 'relative',
                  borderRadius: '32px',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateY(0)',
                  background: `
                    linear-gradient(145deg, 
                      rgba(0, 0, 0, 0.98) 0%, 
                      rgba(10, 10, 10, 0.95) 30%,
                      rgba(5, 5, 5, 0.98) 70%,
                      rgba(0, 0, 0, 0.99) 100%
                    )
                  `,
                  border: `2px solid rgba(255, 255, 255, 0.06)`,
                  backdropFilter: 'blur(30px) saturate(150%)',
                  boxShadow: `
                    0 25px 60px rgba(0, 0, 0, 0.6), 
                    0 5px 20px rgba(0, 0, 0, 0.5),
                    inset 0 1px 0 rgba(255, 255, 255, 0.08),
                    inset 0 -1px 0 rgba(0, 0, 0, 0.4)
                  `,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform =
                    'translateY(-20px) scale(1.03)';
                  e.currentTarget.style.border = `2px solid ${cardStyle.accentColor}60`;
                  e.currentTarget.style.boxShadow = `
                    0 40px 80px rgba(0, 0, 0, 0.8), 
                    0 0 80px ${cardStyle.glowColor}, 
                    0 0 0 3px ${cardStyle.accentColor}30,
                    inset 0 2px 0 rgba(255, 255, 255, 0.10),
                    inset 0 -1px 0 rgba(0, 0, 0, 0.5)
                  `;

                  // Enhance book cover on hover
                  const bookCover = e.currentTarget.querySelector(
                    '.book-cover-container'
                  );
                  if (bookCover) {
                    bookCover.style.transform =
                      'rotateY(-8deg) rotateX(2deg) scale(1.05)';
                    bookCover.style.boxShadow = `
                      0 30px 60px rgba(0, 0, 0, 0.8),
                      0 0 50px ${cardStyle.glowColor},
                      0 0 0 4px rgba(255, 255, 255, 0.15)
                    `;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.border = `2px solid rgba(255, 255, 255, 0.08)`;
                  e.currentTarget.style.boxShadow = `
                    0 25px 60px rgba(0, 0, 0, 0.4), 
                    0 5px 20px rgba(0, 0, 0, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.1),
                    inset 0 -1px 0 rgba(0, 0, 0, 0.2)
                  `;

                  // Reset book cover
                  const bookCover = e.currentTarget.querySelector(
                    '.book-cover-container'
                  );
                  if (bookCover) {
                    bookCover.style.transform =
                      'rotateY(0deg) rotateX(0deg) scale(1)';
                    bookCover.style.boxShadow = `
                      0 20px 40px rgba(0, 0, 0, 0.6),
                      0 0 40px ${cardStyle.glowColor},
                      0 0 0 3px rgba(255, 255, 255, 0.12)
                    `;
                  }
                }}
                onClick={() => onClickCard(book)}
              >
                {/* Animated background particles */}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `
                      radial-gradient(circle at 20% 20%, ${cardStyle.glowColor} 0%, transparent 60%),
                      radial-gradient(circle at 80% 80%, ${cardStyle.accentColor}15 0%, transparent 60%),
                      radial-gradient(circle at 40% 90%, rgba(255, 255, 255, 0.02) 0%, transparent 60%)
                    `,
                    opacity: 0.5,
                    animation: 'pulse 4s ease-in-out infinite alternate',
                  }}
                />

                {/* Premium glassmorphic overlay */}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `
                      linear-gradient(135deg, 
                        rgba(255, 255, 255, 0.06) 0%,
                        rgba(255, 255, 255, 0.01) 20%,
                        transparent 40%,
                        rgba(255, 255, 255, 0.03) 100%
                      )
                    `,
                    borderRadius: '32px',
                  }}
                />

                {/* Book Content Layout */}
                <div
                  style={{
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '2.5rem 2rem',
                    gap: '2rem',
                    minHeight: '420px',
                    textAlign: 'center',
                  }}
                >
                  {/* Book Cover Section */}
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginBottom: '1rem',
                    }}
                  >
                    {/* Enhanced glow effect */}
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '220px',
                        height: '260px',
                        background: `
                          radial-gradient(ellipse, 
                            ${cardStyle.glowColor} 0%, 
                            ${cardStyle.accentColor}30 40%, 
                            transparent 70%
                          )
                        `,
                        filter: 'blur(25px)',
                        opacity: 0.7,
                        animation: 'glow 3s ease-in-out infinite alternate',
                      }}
                    />

                    {/* 3D Book cover container */}
                    <div
                      className='book-cover-container'
                      style={{
                        position: 'relative',
                        width: '170px',
                        height: '220px',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        transform: 'rotateY(0deg) rotateX(0deg) scale(1)',
                        transformStyle: 'preserve-3d',
                        perspective: '1000px',
                        boxShadow: `
                          0 20px 40px rgba(0, 0, 0, 0.6),
                          0 0 40px ${cardStyle.glowColor},
                          0 0 0 3px rgba(255, 255, 255, 0.12)
                        `,
                        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                        background: `
                          linear-gradient(145deg, 
                            rgba(255, 255, 255, 0.08), 
                            rgba(0, 0, 0, 0.4)
                          )
                        `,
                        border: `1px solid rgba(255, 255, 255, 0.12)`,
                      }}
                    >
                      {/* Book spine effect */}
                      <div
                        style={{
                          position: 'absolute',
                          left: '0',
                          top: '0',
                          width: '8px',
                          height: '100%',
                          background: `
                            linear-gradient(180deg, 
                              ${cardStyle.accentColor}40 0%, 
                              ${cardStyle.accentColor}20 50%, 
                              ${cardStyle.accentColor}40 100%
                            )
                          `,
                          borderRadius: '16px 0 0 16px',
                          zIndex: 1,
                        }}
                      />

                      <img
                        src={book.image}
                        alt={book.title}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          filter:
                            'brightness(1.15) contrast(1.1) saturate(1.2)',
                          borderRadius: '16px',
                        }}
                      />

                      {/* Premium overlay */}
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: `
                            linear-gradient(135deg, 
                              rgba(255, 255, 255, 0.05) 0%,
                              transparent 30%,
                              rgba(0, 0, 0, 0.2) 100%
                            )
                          `,
                          borderRadius: '16px',
                        }}
                      />
                    </div>

                    {/* Enhanced Amazon badge */}
                  </div>

                  {/* Book Info Section */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    {/* Category badge */}
                    {/* <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: `
                            linear-gradient(135deg, 
                              ${cardStyle.accentColor}15 0%, 
                              ${cardStyle.accentColor}08 100%
                            )
                          `,
                        border: `1px solid ${cardStyle.accentColor}30`,
                        borderRadius: '25px',
                        padding: '6px 16px',
                        marginBottom: '1rem',
                        backdropFilter: 'blur(10px)',
                      }}
                    >
                      <i
                        className='icon-book'
                        style={{
                          color: cardStyle.accentColor,
                          fontSize: '14px',
                        }}
                      />
                      <span
                        style={{
                          color: cardStyle.accentColor,
                          fontSize: '0.8rem',
                          fontWeight: '600',
                          textTransform: 'uppercase',
                          letterSpacing: '1px',
                        }}
                      >
                        Book
                      </span>
                    </div> */}

                    <h5
                      style={{
                        fontSize: 'clamp(1.4rem, 2.5vw, 1.2rem)',
                        fontWeight: '900',
                        background: `
                            linear-gradient(135deg, 
                              #ffffff 0%, 
                              ${cardStyle.accentColor} 40%,
                              #f1f5f9 70%,
                              #e2e8f0 100%
                            )
                          `,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        marginBottom: '1rem',
                        lineHeight: '1.3',
                        letterSpacing: '0.5px',
                        textShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                      }}
                    >
                      {book.title}
                    </h5>

                    <p
                      style={{
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontSize: '0.8rem',
                        lineHeight: '1.5',
                        marginBottom: '1.5rem',
                        letterSpacing: '0.3px',
                        fontWeight: '400',
                        textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                        maxWidth: '280px',
                      }}
                    >
                      {book.text}
                    </p>

                    {/* Enhanced Features */}
                    {book.features && (
                      <div
                        style={{
                          marginBottom: '2rem',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '0.75rem',
                          width: '100%',
                          maxWidth: '300px',
                        }}
                      >
                        {book.features.map((feature, idx) => (
                          <div
                            key={idx}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                              padding: '12px 16px',
                              background: `
                                  linear-gradient(135deg, 
                                    rgba(255, 255, 255, 0.03) 0%,
                                    rgba(0, 0, 0, 0.4) 100%
                                  )
                                `,
                              borderRadius: '12px',
                              border: `1px solid rgba(255, 255, 255, 0.05)`,
                              backdropFilter: 'blur(10px)',
                              transition: 'all 0.3s ease',
                              cursor: 'default',
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = `
                                  linear-gradient(135deg, 
                                    ${cardStyle.accentColor}08 0%,
                                    rgba(0, 0, 0, 0.5) 100%
                                  )
                                `;
                              e.target.style.border = `1px solid ${cardStyle.accentColor}20`;
                              e.target.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = `
                                  linear-gradient(135deg, 
                                    rgba(255, 255, 255, 0.03) 0%,
                                    rgba(0, 0, 0, 0.4) 100%
                                  )
                                `;
                              e.target.style.border = `1px solid rgba(255, 255, 255, 0.05)`;
                              e.target.style.transform = 'scale(1)';
                            }}
                          >
                            <div
                              style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '8px',
                                background: `
                                    linear-gradient(135deg, 
                                      ${cardStyle.accentColor}25 0%, 
                                      ${cardStyle.accentColor}10 50%,
                                      rgba(0, 0, 0, 0.3) 100%
                                    )
                                  `,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                boxShadow: `
                                    0 4px 12px ${cardStyle.glowColor}, 
                                    inset 0 1px 0 rgba(255, 255, 255, 0.1)
                                  `,
                                border: `1px solid ${cardStyle.accentColor}15`,
                              }}
                            >
                              <i
                                className={`${feature.icon}`}
                                style={{
                                  color: cardStyle.accentColor,
                                  fontSize: '14px',
                                  filter: `drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))`,
                                }}
                              />
                            </div>
                            <span
                              style={{
                                color: 'rgba(255, 255, 255, 0.95)',
                                fontSize: '1rem',
                                fontWeight: '500',
                                lineHeight: '1.4',
                                flex: 1,
                                textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                              }}
                            >
                              {feature.text}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Enhanced Purchase button */}
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <button
                        style={getButtonStyle('amazon', cardStyle)}
                        onMouseEnter={(e) => {
                          e.target.style.transform =
                            'translateY(-6px) scale(1.08)';
                          e.target.style.boxShadow = `
                            0 25px 60px rgba(0, 0, 0, 0.6), 
                            0 0 50px rgba(255, 255, 255, 0.3),
                            inset 0 2px 0 rgba(255, 255, 255, 0.25),
                            inset 0 -2px 0 rgba(0, 0, 0, 0.3)
                          `;
                          e.target.style.background = `
                            linear-gradient(135deg, 
                              rgba(255, 255, 255, 0.15) 0%, 
                              rgba(0, 0, 0, 0.9) 50%,
                              rgba(255, 255, 255, 0.1) 100%
                            )
                          `;
                          e.target.style.border =
                            '2px solid rgba(255, 255, 255, 0.5)';
                          e.target.style.color = '#ffffff';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0) scale(1)';
                          e.target.style.boxShadow = getButtonStyle(
                            'amazon',
                            cardStyle
                          ).boxShadow;
                          e.target.style.background = getButtonStyle(
                            'amazon',
                            cardStyle
                          ).background;
                          e.target.style.border = getButtonStyle(
                            'amazon',
                            cardStyle
                          ).border;
                          e.target.style.color = '#ffffff';
                        }}
                      >
                        Buy
                        <span
                          style={{
                            marginLeft: '8px',
                            fontSize: '16px',
                            border: 'none',
                            outline: 'none',
                            boxShadow: 'none',
                            background: 'transparent',
                          }}
                        >
                          →
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Enhanced shine effect */}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '-150%',
                    width: '150%',
                    height: '100%',
                    background: `
                      linear-gradient(
                        120deg, 
                        transparent 0%, 
                        rgba(255, 255, 255, 0.1) 45%,
                        rgba(255, 255, 255, 0.2) 50%, 
                        rgba(255, 255, 255, 0.1) 55%,
                        transparent 100%
                      )
                    `,
                    transition: 'left 1s cubic-bezier(0.4, 0, 0.2, 1)',
                    pointerEvents: 'none',
                    borderRadius: '32px',
                    transform: 'skewX(-20deg)',
                    zIndex: 3,
                  }}
                  className='card-shine-effect'
                />
              </div>
            );
          })}
        </div>

        {/* Bottom decorative element */}
        <div
          style={{
            textAlign: 'center',
            marginTop: '4rem',
            opacity: 0.4,
          }}
          data-aos='fade-up'
          data-aos-duration='800'
          data-aos-delay='600'
        >
          <div
            style={{
              width: '100px',
              height: '2px',
              background:
                'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
              margin: '0 auto',
            }}
          />
        </div>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
          .shine-effect {
            opacity: 0;
          }
          
          *:hover > .shine-effect {
            left: 120% !important;
            opacity: 1;
          }

          .card-shine-effect {
            opacity: 0;
          }
          
          .book-card:hover .card-shine-effect {
            left: 150% !important;
            opacity: 1;
          }

          .book-card:hover .button-shine {
            left: 100% !important;
          }

          @keyframes pulse {
            0% { opacity: 0.4; transform: scale(0.95); }
            100% { opacity: 0.8; transform: scale(1.05); }
          }

          @keyframes glow {
            0% { 
              opacity: 0.6;
              filter: blur(30px);
              transform: translate(-50%, -50%) scale(0.9);
            }
            100% { 
              opacity: 1;
              filter: blur(25px);
              transform: translate(-50%, -50%) scale(1.1);
            }
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
          
          @media (max-width: 1200px) {
            .books-grid {
              grid-template-columns: 1fr !important;
              gap: 2.5rem !important;
              max-width: 800px !important;
            }
          }
          
          @media (max-width: 768px) {
            .services-grid {
              grid-template-columns: 1fr !important;
              gap: 1.5rem !important;
            }
            
            .books-grid {
              grid-template-columns: 1fr !important;
              gap: 2rem !important;
              max-width: 100% !important;
              padding: 0 1rem !important;
            }
            
            .book-card > div {
              padding: 2rem 1.5rem !important;
              gap: 1.5rem !important;
              min-height: auto !important;
            }

            .book-cover-container {
              width: 160px !important;
              height: 200px !important;
            }
          }
          
          @media (max-width: 480px) {
            .services-grid, .books-grid {
              padding: 0 0.5rem !important;
            }

            .book-card {
              border-radius: 24px !important;
            }
            
            .book-card > div {
              padding: 1.5rem 1rem !important;
              gap: 1.2rem !important;
            }

            .book-cover-container {
              width: 140px !important;
              height: 180px !important;
            }

            .books-grid {
              gap: 1.5rem !important;
            }
          }

          /* Enhanced book card transitions */
          .book-card {
            will-change: transform, box-shadow;
          }

          .book-cover-container {
            will-change: transform, box-shadow;
          }

          /* Improve performance for animations */
          .book-card *[style*="transition"],
          .book-card *[style*="animation"] {
            backface-visibility: hidden;
            perspective: 1000px;
          }

          /* Custom scrollbar for feature lists if needed */
          .book-card div[style*="overflow: hidden"] {
            scrollbar-width: thin;
            scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
          }

          .book-card div[style*="overflow: hidden"]::-webkit-scrollbar {
            width: 4px;
          }

          .book-card div[style*="overflow: hidden"]::-webkit-scrollbar-track {
            background: transparent;
          }

          .book-card div[style*="overflow: hidden"]::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.2);
            border-radius: 2px;
          }
        `,
        }}
      />
    </section>
  );
}
